export default {
    date: {
        label: 'onlineSchedule.date',
        type: 'general',
        field: 'date',
        align: 'left',
        customWidth: 100,
        render: true,
        fixed: false,
    },
    branch: {
        label: 'Lojas',
        field: 'branch',
        type: 'general',
        align: 'left',
        customWidth: 220,
        fixed: false,
        render: true,
    },
    lm: {
        label: 'lm_label',
        field: 'lm',
        type: 'general',
        align: 'left',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    desc: {
        label: 'reports.description',
        field: 'desc',
        type: 'general',
        align: 'left',
        customWidth: 170,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    section: {
        label: 'delimit.report.table.section',
        field: 'section',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    batch: {
        label: 'Lote',
        field: 'batch',
        type: 'general',
        align: 'left',
        customWidth: 70,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    depositType: {
        label: 'Tipo de depósito',
        field: 'depositType',
        type: 'general',
        align: 'left',
        customWidth: 140,
        fixed: false,
        render: true,
        disableOrder: false,
    },
    depositPosition: {
        label: 'Posição no depósito',
        field: 'depositPosition',
        type: 'general',
        align: 'left',
        customWidth: 156,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    preIRCStock: {
        label: 'Estoque pré IRC',
        field: 'preIRCStock',
        type: 'general',
        align: 'left',
        customWidth: 140,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    supplier: {
        label: 'Fornecedor',
        field: 'supplier',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    },
};
